import Details from "../components/Details";
import Navigation from "../components/Navigation";

export default function Fees(){
    return(
        <>
        <Navigation/>
        
        <div className="payment-recipt">

        </div>
        </>
    )
}